import * as XLSX from "xlsx";
import get from "lodash/get";
import map from "lodash/map";

export const exportToExcel = (headers, data, mapKeys, fileName = "data.xlsx") => {
  const rows = map(data, (item, index) =>
    Object.fromEntries(
      map(headers, (header) => {
        if (header === "S.N.") {
          return [header, index + 1];
        }
        if(header==='Staff Manager'&& get(item, mapKeys["Role"])==="Manager"){
          return['Staff Manager', get(item, mapKeys['Staff Name'])];
        }
        if(header==='Staff Manager ID'&& get(item, mapKeys["Role"])==="Manager"){

         return ['Staff Manager ID', get(item, mapKeys['Staff ID'])]
        }
        return [header, get(item, mapKeys[header]) ?? ""];
      })
    )
  );

  const worksheet = XLSX.utils.json_to_sheet(rows, {
    header: headers,
    skipHeader: false,
  });

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  XLSX.writeFile(workbook, fileName);
};
